import React, { useState } from 'react'
import { SortBy } from '@interfaces/filters'
import Icon from '@components/atoms/Icon'

interface SortDropdownProps {
  sortBy: SortBy
  onSortChange: (value: string) => void
}

const SortDropdown: React.FC<SortDropdownProps> = ({ sortBy, onSortChange }) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleOptionClick = (value: string) => {
    onSortChange(value)
    setIsOpen(false)
  }

  return (
    <div className="relative z-5">
      <div
        className="border rounded-sm border-blue-1 shadow-thumbnail bg-gradient-model-grey flex items-center gap-2 py-2.5 px-4"
        aria-controls="dropdown-list"
        aria-haspopup="menu"
        aria-expanded={isOpen}
        role="button"
        tabIndex={0}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="whitespace-nowrap">{window.DEPT.Strings.filters.sortBy}</div>
        <span className={`transition ${isOpen ? 'rotate-180' : ''}`}>
          <Icon name="chevron-down" className="text-black w-4 h-4" />
        </span>
      </div>
      <nav
        className={`absolute top-14 right-0 border rounded-sm border-blue-1 shadow-thumbnail bg-gradient-model-grey ${
          isOpen ? 'flex flex-col' : 'hidden'
        }`}
        aria-labelledby="dropdown-toggle"
        style={{
          animation: isOpen ? 'dropdownItemIn 0.3s ease-in-out, fadeIn 0.4s ease-in-out' : '',
          animationFillMode: 'forwards',
        }}
      >
        <ul className="py-2.5 px-4">
          {sortBy.options.map((option) => (
            <li
              key={option.value}
              className="cursor-pointer whitespace-nowrap"
              tabIndex={0}
              onClick={() => handleOptionClick(option.value)}
            >
              {option.name}
            </li>
          ))}
        </ul>
      </nav>
    </div>
  )
}

export default SortDropdown
